module.exports = __webpack_public_path__ + "static/assets/eb965ba88ced446fbd45955fe708beba.png";